<header class="dialog-header">
  <h3 class="header-heading">{{ 'pages.user-subscriptions.management-dialog.heading' | translate }}</h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>

<div class="dialog-content">
  <div class="row">
    <span class="label">{{ 'pages.user-subscriptions.management-dialog.name' | translate }}</span>
    <span class="data">{{ data.name }}</span>
  </div>
  <div class="row">
    <span class="label">{{ 'pages.user-subscriptions.management-dialog.code' | translate }}</span>
    <span class="data">{{ data.code }}</span>
  </div>
  <div class="row">
    <span class="label">{{ 'pages.user-subscriptions.management-dialog.startDate' | translate }}</span>
    <span class="data">{{ data.startDate | shortDate }}</span>
  </div>
  <div class="row">
    <span class="label margin-bottom">{{ 'pages.user-subscriptions.management-dialog.endDate' | translate }}</span>
    <div class="data" [formGroup]="form">
      <app-form-datepicker formControlName="endDate" [min]="startDate"></app-form-datepicker>
    </div>
  </div>
</div>

<footer class="dialog-footer">
  <button class="bciti-button bciti-button--blue"
    [disabled]="loading"
    (click)="submit()">
    <span *ngIf="!loading">{{ 'pages.user-subscriptions.management-dialog.button.save' | translate }}</span>
    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
  </button>
</footer>
